module.exports = __webpack_public_path__ + "img/UTGUNL.05f03177.png";